import { defineFieldDisplay } from "../defines";
import RelatedValuesM2M from "./related-values-list-o2m.vue";

export default defineFieldDisplay({
  id: "related-values-list-o2m",
  component: RelatedValuesM2M,
});
